export default __webpack_public_path__ + "static/media/pagesix.cf0f2cbc.txt";